module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_home-365d57685f442fcf302cc1308c052f90.svg";